import { BsPlus } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

const ClientsToolbar = ({ setSearchClient }) => {
  const [SearchClient, setSearchClientState] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    
    const value = e.target.value;
    setSearchClientState(value);
    setSearchClient(value);
    
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="relative">
        <FiSearch
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search clients"
          className="border pl-9 pr-3 py-2 rounded text-sm input-field"
          value={SearchClient}
          maxLength={256}
          onChange={handleSearchChange}
        />
      </div>

      <button className="btn-add px-4" title="Add" onClick={() => navigate("/clients/add")}>
        <BsPlus size={26} color="#ffffff" /> Client
      </button>
    </div>
  );
};

export default ClientsToolbar;
